import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
  },
  {
    // 后端需要返回，但是前端需要给隐藏
    path: '/:pathMatch(.*)*', // 路由访问路径没有，默认跳转404
    name: 'ANY',
    component: () => import('../views/wasteland.vue'),
  },
  // {
  //   path: '/product',
  //   name: 'Product',
  //   component: ()=>import('../views/product.vue')
  // },{
  //   path: '/download',
  //   name: 'Download',
  //   component: ()=>import('../views/download.vue')
  // },{
  //   path: '/support',
  //   name: 'Support',
  //   component: ()=>import('../views/support.vue')
  // },{
  //   path: '/forum',
  //   name: 'Forum',
  //   component: ()=>import('../views/forum.vue')
  // }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
